import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	page: {
		height: '100%',
		boxSizing: 'border-box',
		paddingBlock: token('space.200'),
		paddingInlineStart: token('space.400'),
		paddingInlineEnd: token('space.200'),
		backgroundColor: token('elevation.surface.sunken'),
		overflowY: 'auto',
	},
	main: {
		minWidth: '0px',
		width: '100%',
	},
	actionRow: {
		display: 'flex',
		alignItems: 'center',
		columnGap: token('space.100'),
		rowGap: token('space.100'),
		paddingBlock: token('space.100'),
		flexWrap: 'wrap',
	},
	panelFrame: {
		height: '100%',
		width: '100%',
		boxSizing: 'border-box',
		paddingBlockStart: token('space.200'),
		paddingBlockEnd: token('space.400'),
		paddingInline: token('space.200'),
		backgroundColor: token('elevation.surface.sunken'),
	},
	panel: {
		height: '100%',
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.medium'),
		backgroundColor: token('elevation.surface'),
		boxShadow: token('elevation.shadow.raised'),
		overflow: 'hidden',
	},
});

export const QueryWorkbenchPage = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => (
	<Box xcss={styles.page} testId="query-workbench-page">
		<Box xcss={styles.main}>{children}</Box>
	</Box>
);

export const QueryWorkbenchActionRow = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => (
	<Box xcss={styles.actionRow} testId="query-workbench-action-row">
		{children}
	</Box>
);

export const QueryWorkbenchFloatingPanelFrame = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => (
	<Box xcss={styles.panelFrame} testId="query-workbench-floating-panel-frame">
		<Box xcss={styles.panel}>{children}</Box>
	</Box>
);
